var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.37 17.618a.959.959 0 01-.945.836 15.95 15.95 0 01-11.234-4.686A15.95 15.95 0 011.505 2.534a.959.959 0 01.837-.944l3.09-.441a1 1 0 011.061.596l1.553 3.623a1 1 0 01-.212 1.1L6.741 7.563a.937.937 0 00-.222 1.016 8.945 8.945 0 004.862 4.863.937.937 0 001.016-.222l1.094-1.093a1 1 0 011.1-.213l3.624 1.553a1 1 0 01.596 1.06l-.442 3.092z",
    fill: "#1C1D1F"
  })));
}

export default SvgIbCallIcon;